/* ============================================================
   SIZE ASSISTANT — assets/size-assistant.js
   No frameworks, no network requests, no dependencies.
   ============================================================ */

(function () {
  'use strict';

  // ── SIZE CHARTS ────────────────────────────────────────────
  var SIZE_CHARTS = {
    tshirt: {
      label: 'T-Shirt',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      measurements: {
        S:    { width: 46,   length: 71 },
        M:    { width: 51,   length: 74 },
        L:    { width: 56,   length: 76 },
        XL:   { width: 61,   length: 79 },
        XXL:  { width: 66,   length: 81 },
        XXXL: { width: 71,   length: 84 }
      }
    },
    sweatshirt: {
      label: 'Sweatshirt',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', '3XL'],
      measurements: {
        S:     { width: 51, length: 69 },
        M:     { width: 56, length: 71 },
        L:     { width: 61, length: 74 },
        XL:    { width: 66, length: 76 },
        XXL:   { width: 71, length: 79 },
        '3XL': { width: 76, length: 81 }
      }
    },
    hoodie: {
      label: 'Hoodie',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      measurements: {
        S:    { width: 50.8, length: 68.6 },
        M:    { width: 55.9, length: 71.1 },
        L:    { width: 61.0, length: 73.7 },
        XL:   { width: 66.0, length: 76.2 },
        XXL:  { width: 71.1, length: 78.7 },
        XXXL: { width: 76.2, length: 81.3 }
      }
    },
    ecotshirt: {
      label: 'Ekologisk T-Shirt',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL'],
      measurements: {
        XS:   { width: 48, length: 64 },
        S:    { width: 50, length: 70 },
        M:    { width: 53, length: 72 },
        L:    { width: 56, length: 74 },
        XL:   { width: 59, length: 76 },
        XXL:  { width: 62, length: 78 },
        '3XL': { width: 65, length: 80 },
        '4XL': { width: 68, length: 82 }
      }
    },
    baby: {
      label: 'Baby T-Shirt',
      sizes: ['6M', '12M', '18M', '24M'],
      measurements: {
        '6M':  { width: 50.8, length: 31.7 },
        '12M': { width: 55.8, length: 34.2 },
        '18M': { width: 61,   length: 36.7 },
        '24M': { width: 66,   length: 39.3 }
      }
    },
    junior: {
      label: 'Junior T-Shirt',
      sizes: ['XS', 'S', 'M', 'L', 'XL'],
      measurements: {
        XS: { width: 81.2,  length: 52.1 },
        S:  { width: 86.4,  length: 55.9 },
        M:  { width: 91.4,  length: 59.7 },
        L:  { width: 96.6,  length: 63.5 },
        XL: { width: 101.6, length: 67.3 }
      }
    }
  };

  // ── REVIEW DATA ────────────────────────────────────────────
  // Replace entries below with your real reviews.
  // fit_score scale: 0 = way too small · 50 = perfect · 100 = way too big
  // This data is also mirrored in assets/sizeReviews.json for reference.
  var SIZE_REVIEWS = [
    {
      "reviewer": "Felicia Seidel",
      "product_type": "sweatshirt",
      "fit_score": 50,
      "quote": "Jättefin, den är helt perfekt!",
      "show_quote": false
    },
    {
      "reviewer": "Filippa J",
      "product_type": "t-shirt",
      "fit_score": 30,
      "quote": "fint tryck, fin tröja och blixtsnabb leverans. gillar att man får ett mail med hur bilderna kommer bli innan så man kan säga till ifall det inte känns bra.\r\nlite dyra dock.",
      "show_quote": false
    },
    {
      "reviewer": "Selma Boudali",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Min man var jättenöjd med hans T-shirt. Måste tacka Obsessed för ett smidigt köp och leverans. Designförslaget skickades snabbt och paketet kom fram i tid!",
      "show_quote": false
    },
    {
      "reviewer": "Anonym",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Älskar T-shirten. Ska ha den på hans konsert nästa vecka",
      "show_quote": false
    },
    {
      "reviewer": "Anonym",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Älskar trycket. Bra av man får bild på hur dom kommer se ut så man vet om man är nöjd eller inte. Och snabb leverans. Så leveransen är som det står att det ska vara. Men lite dyra. Tänker på dom som inte har så mycket pengar",
      "show_quote": false
    },
    {
      "reviewer": "Ellen Öman",
      "product_type": "t-shirt",
      "fit_score": 40,
      "quote": "Jättebra att man får ändra designen tills man är nöjd. När jag fick hem tröjan ser den ut som på bilden. Supernöjd!",
      "show_quote": false
    },
    {
      "reviewer": "Amanda Vahlström",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Jätte effektivt och snabbt! Kunde göra ändringar utan problem och det blev jättebra tillslut!",
      "show_quote": false
    },
    {
      "reviewer": "Olivia Björkström",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Snabbt, smidigt och enkelt. Nöjd över resultatet",
      "show_quote": false
    },
    {
      "reviewer": "Tilda Bohlin",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Bra kvalitet och jättetrevligt bemötande på kundservice!",
      "show_quote": false
    },
    {
      "reviewer": "Agnes Schuller",
      "product_type": "t-shirt",
      "fit_score": 60,
      "quote": "Älskar!!!! Det gick snabbt och lätt att få tröjan och ni var så snälla som kunde göra om den så många gånger som jag frågade. Han är också super nöjd med den!!😍😍 10\\10",
      "show_quote": false
    },
    {
      "reviewer": "Emma",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Helt underbar service, gör precis som man vill även om man vill ändra något. Superbra kvalitet både på trycket och tröjan själv. Rekommenderar verkligen!!!",
      "show_quote": false
    },
    {
      "reviewer": "Vilda Wall",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Min kille kunde inte tro sina ögon när han såg tröjan. Både han och jag är nöjda med den!",
      "show_quote": false
    },
    {
      "reviewer": "Anna K",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Toppenfint, snabb service och jättebra resultat!",
      "show_quote": false
    },
    {
      "reviewer": "Johanna Ekström",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Snabb leverans trots alla hjärnas dag och superfint tryck och kvaliteten verkar super än sålänge! Jättenöjd!",
      "show_quote": false
    },
    {
      "reviewer": "Emma Rosén",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Så smidig beställning och snabb leverans. Jättenöjd med resultatet! 🤩",
      "show_quote": false
    },
    {
      "reviewer": "Frida Hallgren",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Så fin och bra kvalitet",
      "show_quote": false
    },
    {
      "reviewer": "Sabina Hunter",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Gav denna t-shirt till min man på alla hjärtans dag.\r\nHan blev super nöjd och tyckte det var en jätterolig idé.\r\nLeveransen gick snabbt och smidigt. Fick ett tydligt utkast på hur produkten skulle se ut innan den gick i tryck. Det var väldigt uppskattat! Kommer högst troligt köpa härifrån igen.",
      "show_quote": false
    },
    {
      "reviewer": "Hissrum",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Jättefin och bra kvalitet!",
      "show_quote": false
    },
    {
      "reviewer": "Sabina Sahovic",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Hade varit roligt att samarbeta med er",
      "show_quote": false
    },
    {
      "reviewer": "Linn J",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Obsessed har verkligen bra kundservice. De bytte ut en bild som jag inte var helt nöjd med supersnabbt. Tröjan blev jättesnygg och jag längtar tills jag får ge den!",
      "show_quote": false
    },
    {
      "reviewer": "Erica Andersson",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Super fin och är så nöjd, dem e så trevliga med att göra designen för tröjan och ger dig alltid ett ungefär hur den ser ut innan den gör tröjan så man kan alltid hinna ändra på vissa saker",
      "show_quote": false
    },
    {
      "reviewer": "Evelina E",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Jätte trevliga och hjälpsamma! Snabba svar. Och T-shirten blev succé 🙌🏻",
      "show_quote": false
    },
    {
      "reviewer": "Rebecka",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Mannen blev helnöjd med sin present! Snabb leverans ⭐️",
      "show_quote": false
    },
    {
      "reviewer": "Diana Ristic",
      "product_type": "t-shirt",
      "fit_score": 60,
      "quote": "Sykt fin og bildene ble sykt bra. Det var også veldig bra kundeservice som endret på hvordan jeg ville ha bildene eller ville bytte ut noen bilder. Fikk veldig raskt svar også!",
      "show_quote": false
    },
    {
      "reviewer": "Alma Mix",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Kom snabbt och smidigt! Sambon älskar tröjan 😍",
      "show_quote": false
    },
    {
      "reviewer": "Fanny Järvengren",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Allt gick så smidigt, snabbt och enkelt. Jag är väldigt nöjd med min tröja.",
      "show_quote": false
    },
    {
      "reviewer": "Sara Divall",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "En otrolig fin tröja kunde få den exakt så jag ville den skulle se ut!",
      "show_quote": true
    },
    {
      "reviewer": "Nina",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Allt var super smidigt och gick så snabbt! Prisvärt och en rolig present till pojkvännen som är personlig✨",
      "show_quote": true
    },
    {
      "reviewer": "Alma Jansson",
      "product_type": "t-shirt",
      "fit_score": 70,
      "quote": "Super bra material, älskar😍",
      "show_quote": true
    },
    {
      "reviewer": "Ellen Talo",
      "product_type": "sweatshirt",
      "fit_score": 30,
      "quote": "Tröjan var verkligen hur snygg som helst, men blev lite för liten. Tog M eftersom storleksguiden visade att L skulle vara väldigt väldigt lång.",
      "show_quote": false
    },
    {
      "reviewer": "Mathilde Rybråten Engebretsen",
      "product_type": "t-shirt",
      "fit_score": 60,
      "quote": "Trykk på t-skjorten var fint. Stoffet på tskjorten var godt. Tåler fint å vaskes. Veldig fornøyd!",
      "show_quote": false
    },
    {
      "reviewer": "Nadia van Lochem",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Bought this for our 1st year anniversary, I ordered about a week before and was nervous it wouldn't arrive on time, but I got it as promised on the website.",
      "show_quote": false
    },
    {
      "reviewer": "Paola Stiernspetz",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "hade ett problem med min första order och kundservice hjälpte mig direkt och var så gulliga. Är extremt nöjd med resultatet! Bästa presenten!!!",
      "show_quote": false
    },
    {
      "reviewer": "Marisa Örnbielke",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Andra gången jag beställer härifrån, 3e T-shirten och är mycket nöjd! Bra kvalite och rolig design! Tusen tack!",
      "show_quote": false
    },
    {
      "reviewer": "Gabriella Vesterberg Szymanski",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Väldigt bra service, och tillgodoser vilja önskemål man har och är möjliga till att se till att jag som kund blir nöjd.",
      "show_quote": false
    },
    {
      "reviewer": "Sandra Hjertén",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Kvaliteten på T-shirten och trycker var över förväntan! Riktigt kul. Hoppas att min blivande blir glad att få en sån här t-shirt från mig!",
      "show_quote": false
    },
    {
      "reviewer": "Ida Lundberg",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Trycket såg fint ut, tröjan var fin och jag var rädd att man inte skulle se själva trycken när man satte på det på tröjan men det var bra",
      "show_quote": false
    },
    {
      "reviewer": "Mimmi Johansson",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Så så nöjd! Snabb leverans och jätte fin tröja. Bra pris med ett lätt sätt att skapa din egna design! 10/10",
      "show_quote": false
    },
    {
      "reviewer": "Emelie",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Tröjan är jätte bekväm och har jättebra material, bilderna är jättebra tryckta och ser jättebra ut.",
      "show_quote": false
    },
    {
      "reviewer": "Clara Vijkman",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Min kille blev jätteglad för tröjan, leveransen var också otroligt snabb och man fick göra flera designutkast tills man kände sig helt nöjd! 12/10🌟🌟",
      "show_quote": false
    },
    {
      "reviewer": "Ulrika B",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Mycket snygg och välgjord. Snabb leverans.",
      "show_quote": false
    },
    {
      "reviewer": "Johanna",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Väldigt rolig och fin tröja som sambon uppskattade! Varför inte 5 stjärnor är för att trycket känns igenom så den var inte superbekväm.  Tyvärr tog jag hans normala storlek M och hoppades på en oversized passform men den var för liten, men det är ju mitt fel. Borde tagit storlek L eller XL",
      "show_quote": false
    },
    {
      "reviewer": "Amanda Palm",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Sjukt fin! Snabb leverans och så himla nöjd❤️",
      "show_quote": false
    },
    {
      "reviewer": "Anna",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Så otroligt fint, snabb produktion och leverans!",
      "show_quote": false
    },
    {
      "reviewer": "Frida Lundgren",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Så skön T-shirt! Bra material! Bilderna blev jättebra! Bra i storleken!",
      "show_quote": true
    },
    {
      "reviewer": "Caroline",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Riktigt fin t-shirt, bra kvalitet i både tyg och tryck! Snabb leverans. Allt tipp topp!",
      "show_quote": false
    },
    {
      "reviewer": "Victoria Bennström",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Fenomenalt bra",
      "show_quote": false
    },
    {
      "reviewer": "Nathalie Dahlund",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Hej! Min kille älskade tröjan och den var jätte snygg! Och bra kvalitet! Bästa tröjan han har!",
      "show_quote": false
    },
    {
      "reviewer": "Johanna Vrede",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Sååå himla snygg!!",
      "show_quote": false
    },
    {
      "reviewer": "Matilda Olsson",
      "product_type": "t-shirt",
      "fit_score": 70,
      "quote": "Min kille blev superglad över tröjan. Den va i bra material. Dock var den liiiite för stor (tog en storlek större eftersom det rekommenderades av hemsidan). Men hellre för stor än för liten",
      "show_quote": false
    },
    {
      "reviewer": "Maria Tawfik",
      "product_type": "sweatshirt",
      "fit_score": 50,
      "quote": "Mycket bra",
      "show_quote": true
    },
    {
      "reviewer": "Johanna",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Andra gången jag beställde från Obsessed. Super nöjd! Snabb leverans och precis som jag önskade det 😍",
      "show_quote": false
    },
    {
      "reviewer": "Emma",
      "product_type": "sweatshirt",
      "fit_score": 50,
      "quote": "Så fina tröjor! Super nöjd med mitt köp, sköna tröjor också. Killen älskar dom!",
      "show_quote": true
    },
    {
      "reviewer": "Rebecka Nilsson",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Hade tröjan inom en vecka efter att jag beställt, den såg precis ut som på bilden. Har inget negativt att säga:)",
      "show_quote": false
    },
    {
      "reviewer": "Felicia Forsvik",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Toppen",
      "show_quote": false
    },
    {
      "reviewer": "Paulina",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Det gick så snabbt att få svar på frågor på instagram och sen att få både designen och tröjan. Bra blev det med!",
      "show_quote": false
    },
    {
      "reviewer": "Elsa Månspers",
      "product_type": "t-shirt",
      "fit_score": 70,
      "quote": "Jättebra koncept där man kan anpassa bilderna och placera precis som man vill ha dom! Det känns väldigt tryggt också att få se ett utkast av designen innan den trycks, så man kan ändra ifall något skulle se skumt ut! Dessutom var det ASSNABB leveranstid! \r\nJag är jättenöjd, tröjan var precis det jag hade önskat!",
      "show_quote": false
    },
    {
      "reviewer": "Vanessa",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Super service, designteamet 10/10, och produkten perfekt!",
      "show_quote": false
    },
    {
      "reviewer": "Alexandra Widås Immonen",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Väldigt snygg!! O tröjan ser inte så dum ut heller!\r\nJkjk är super nöjd o hoppas min kille kommer älska den!",
      "show_quote": false
    },
    {
      "reviewer": "Rebecca",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Känns som bra kvalité. Mycket nöjd med kundservice som var väldigt tillmötesgående när jag ville göra flera ändringar. Kul julklapp till sambon!",
      "show_quote": false
    },
    {
      "reviewer": "Thaleia Svenfelt",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Super!",
      "show_quote": false
    },
    {
      "reviewer": "Ebba Widén",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Var otroligt dålig på att informera om status på mitt paket, samt att de tog 10 dagar extra. Men kvaliten är superbra så det är jag nöjd över",
      "show_quote": false
    },
    {
      "reviewer": "Elin Ek",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Otroligt nöjd med produkternas design och material!\r\nDessvärre tog det 4 veckor för produkterna att komma..\r\n(5 stjärnor för produkterna, 1 stjärna för leveransen)",
      "show_quote": false
    },
    {
      "reviewer": "Moonika Klemetti",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Tack! Kiitos! Thank you!",
      "show_quote": false
    },
    {
      "reviewer": "N",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "He’s always wearing it!",
      "show_quote": false
    },
    {
      "reviewer": "Ella Jansson",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Snygg design och snabb leverans!! Super ⭐️⭐️",
      "show_quote": false
    },
    {
      "reviewer": "Rebecca Liljedahl Lager",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Mycket bra service och material på tröjan",
      "show_quote": false
    },
    {
      "reviewer": "Ella Hadzic",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Egen designad tröja var jätte fin och rätt storlek, men bilden man kan beställa önskade bara det var lite tydligare vart texten skulle stå på bilden nu blev det att bilden var ganska långt ner och texten täcker över annars jätte fint",
      "show_quote": false
    },
    {
      "reviewer": "Jennifer Gustafsson",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Bra service",
      "show_quote": false
    },
    {
      "reviewer": "Ranja Khalaf",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Jag älskar dom!!!😍 verkligen bra kvalité och super fina",
      "show_quote": true
    },
    {
      "reviewer": "Emanda Andersson",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Han blev superglad och trycket blev som förväntat. Storleken är något liten i storlek enligt mig, och T-shirten är inte i så bra kvalité. Men annars nöjd",
      "show_quote": false
    },
    {
      "reviewer": "Erika Dovidaviciene",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Jag är väldigt nöjd med servicen och kvaliteten på tröjan!",
      "show_quote": true
    },
    {
      "reviewer": "Rosa",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Snabb leverans, även om det var precis innan alla hjärtans dag. Det gick smidigt och snabbt att designa tröjan. Jättefin, supernöjd!",
      "show_quote": false
    },
    {
      "reviewer": "Amanda Stommendal",
      "product_type": "t-shirt",
      "fit_score": 40,
      "quote": "Nöjd med design, kvalitet och leveranstid. Eventuellt något små i storlek så är man mellan två storlek, välj den större",
      "show_quote": true
    },
    {
      "reviewer": "Rasmus",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Riktigt bra!",
      "show_quote": false
    },
    {
      "reviewer": "Baraa Abuzaid",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Tröjan va som förväntad och kundservice var jätte bra. Jätttteeee nöjjddd!!",
      "show_quote": true
    },
    {
      "reviewer": "Vanja Brjánsdotter",
      "product_type": "t-shirt",
      "fit_score": 60,
      "quote": "Älskar tröjan jag köpt till min kille. Allt gick snabbt och var väldigt pålitligt. Tog storlek M och tyckte den var ganska stor dock, men det är på mig <3",
      "show_quote": true
    },
    {
      "reviewer": "William Brandberg",
      "product_type": "t-shirt",
      "fit_score": 50,
      "quote": "Väldigt nöjd!",
      "show_quote": false
    }
];

  // ── SIZE ORDER (used for rank comparisons) ─────────────────
  // XXXL and 3XL are treated as the same rank.
  var ALL_SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];

  function sizeRank(size) {
    var s = size === '3XL' ? 'XXXL' : size;
    var idx = ALL_SIZES.indexOf(s);
    return idx === -1 ? 3 : idx; // default to M rank if unknown
  }

  function isKidsType(type) {
  return type === 'baby' || type === 'junior';
  }

  // ── STATE ──────────────────────────────────────────────────
  var productType  = null; // 'tshirt' | 'sweatshirt' | 'hoodie'
  var currentStep  = 0;    // 0=fit, 1=size, 2=measurements, 3=result
  var answers      = {};
  var betweenMode  = false; // sub-state inside step 1
  var focusableEls = [];
  var prevFocus    = null;

  // ── DOM REFS ───────────────────────────────────────────────
  var $trigger, $panel, $overlay, $closeBtn, $body, $progressBar;

  // ── INIT ───────────────────────────────────────────────────
  function init() {
    var root = document.getElementById('size-assistant-root');
    if (!root) return;

    var rawType = (root.getAttribute('data-product-type') || '').toLowerCase().trim();
    productType = normalizeType(rawType);

    $trigger     = document.getElementById('sa-trigger');
    $panel       = document.getElementById('sa-panel');
    $overlay     = document.getElementById('sa-overlay');
    $closeBtn    = document.getElementById('sa-close');
    $body        = document.getElementById('sa-body');
    $progressBar = document.getElementById('sa-progress-bar');

    if (!productType) {
      // Product type not recognised — hide the widget entirely
      if ($trigger) $trigger.style.display = 'none';
      return;
    }

    $trigger.addEventListener('click', openPanel);
    $closeBtn.addEventListener('click', closePanel);
    $overlay.addEventListener('click', closePanel);
    document.addEventListener('keydown', handleKeyDown);
  }

  function normalizeType(raw) {
    var map = {
      // Template suffixes
      'troja':           'tshirt',
      'lover-customily': 'tshirt',
      'sweatshirt':      'sweatshirt',
      'section-brodyr-hoodie':          'hoodie',
      'sweatshirt-2':    'sweatshirt',
      'lover-section-sweatshirt': 'sweatshirt',
      'no-personalization': 'tshirt',
      'vintage': 'tshirt',
      'polaroid': 'tshirt',
      'lover-section-2': 'tshirt',
      'no-configurator': 'tshirt',
      'section-brodyr-tshirt':'ecotshirt',
      'section-brodyr-sweatshirt':'sweatshirt',
      'section-brodyr-klar': 'ecotshirt',
      'klar-brodyr-hoodie': 'hoodie',
      'configurator-tshirt': 'tshirt',
      'configurator-sweatshirt': 'sweatshirt',
      // product.type fallbacks
      't-shirt':         'tshirt',
      'tshirt':          'tshirt',
      't shirt':         'tshirt',
      'hoodie':          'hoodie',
      'brodyr-hoodie':   'hoodie',
      'baby-tshirt':     'baby',
      'brodyr-tshirt':   'ecotshirt',
      'brodyr-sweatshirt': 'sweatshirt',
      'kids-tshirt':     'junior'
    };
    return map[raw] || null;
  }

  // ── OPEN / CLOSE ───────────────────────────────────────────
  function openPanel() {
    prevFocus    = document.activeElement;
    currentStep  = 0;
    answers      = {};
    betweenMode  = false;

    $panel.classList.add('sa-panel--open');
    $panel.setAttribute('aria-hidden', 'false');
    $overlay.classList.add('sa-overlay--visible');
    document.body.style.overflow = 'hidden';
    $trigger.setAttribute('aria-expanded', 'true');

    renderStep();

    requestAnimationFrame(function () {
      var first = $body.querySelector('button, input, select');
      if (first) first.focus();
      refreshFocusTrap();
    });
  }

  function closePanel() {
    $panel.classList.remove('sa-panel--open');
    $panel.setAttribute('aria-hidden', 'true');
    $overlay.classList.remove('sa-overlay--visible');
    document.body.style.overflow = '';
    $trigger.setAttribute('aria-expanded', 'false');
    if (prevFocus && prevFocus.focus) prevFocus.focus();
  }

  function handleKeyDown(e) {
    if (!$panel.classList.contains('sa-panel--open')) return;
    if (e.key === 'Escape') { closePanel(); return; }
    if (e.key === 'Tab')    { trapFocus(e); }
  }

  function trapFocus(e) {
    refreshFocusTrap();
    if (!focusableEls.length) { e.preventDefault(); return; }
    var first = focusableEls[0];
    var last  = focusableEls[focusableEls.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
    }
  }

  function refreshFocusTrap() {
    focusableEls = Array.from(
      $panel.querySelectorAll(
        'button:not([disabled]),[href],input:not([disabled]),select:not([disabled]),' +
        'textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) { return el.offsetParent !== null; });
  }

  // ── RENDER DISPATCHER ──────────────────────────────────────
  function renderStep() {
    updateProgress();

    var html = '';
    if      (currentStep === 0) html = renderFitStep();
    else if (currentStep === 1 && !isKidsType(productType)) html = renderSizeStep();
    else if (currentStep === 2 && !isKidsType(productType)) html = renderMeasurementsStep();
    else if (currentStep === 3) html = renderResult();

    $body.innerHTML = html;
    attachListeners();
    refreshFocusTrap();
  }

  function updateProgress() {
    var widths = isKidsType(productType) ? [99, 100] : [33, 66, 99, 100];
    var pct = widths[Math.min(currentStep, widths.length - 1)];
    if ($progressBar) $progressBar.style.width = pct + '%';
  }

  // ── BACK BUTTON HTML ───────────────────────────────────────
  function backBtn(target) {
    return '<button class="sa-back" data-back="' + target + '" aria-label="G\u00e5 tillbaka">'
      + '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" '
      +      'xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
      +   '<path d="M10 3L5 8L10 13" stroke="currentColor" '
      +         'stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>'
      + '</svg>Tillbaka</button>';
  }

  // ── STEP 0 — Preferred fit (adults) / Age or height (kids) ────
  function renderFitStep() {

    if (productType === 'baby') {
      return '<div class="sa-step">'
        + '<p class="sa-step-label">Steg 1 av 1</p>'
        + '<h3 class="sa-step-question">Hur gammal \u00e4r ditt barn?</h3>'
        + '<div class="sa-options">'
          + '<button class="sa-option" data-action="kidssize" data-value="6M">Under 6 m\u00e5nader</button>'
          + '<button class="sa-option" data-action="kidssize" data-value="12M">6\u201312 m\u00e5nader</button>'
          + '<button class="sa-option" data-action="kidssize" data-value="18M">12\u201318 m\u00e5nader</button>'
          + '<button class="sa-option" data-action="kidssize" data-value="24M">18\u201324 m\u00e5nader</button>'
        + '</div>'
      + '</div>';
    }

    if (productType === 'junior') {
      return '<div class="sa-step">'
        + '<p class="sa-step-label">Steg 1 av 1</p>'
        + '<h3 class="sa-step-question">Hur l\u00e5ng \u00e4r ditt barn?</h3>'
        + '<div class="sa-options">'
          + '<button class="sa-option" data-action="kidssize" data-value="XS">Under 122 cm</button>'
          + '<button class="sa-option" data-action="kidssize" data-value="S">122\u2013128 cm</button>'
          + '<button class="sa-option" data-action="kidssize" data-value="M">128\u2013134 cm</button>'
          + '<button class="sa-option" data-action="kidssize" data-value="L">134\u2013140 cm</button>'
          + '<button class="sa-option" data-action="kidssize" data-value="XL">\u00d6ver 140 cm</button>'
        + '</div>'
      + '</div>';
    }

    // ── Adult flow ──
    var note = productType === 'hoodie'
      ? '<p class="sa-step-note">Den h\u00e4r hoodien har en avslappnad unisex-passform. V\u00e4lj Oversized om du vill ha det rymliga, nedtagna axelpartiet \u2014 vi anpassar rekommendationen.</p>'
      : '';

    return '<div class="sa-step">'
      + '<p class="sa-step-label">Steg 1 av 3</p>'
      + '<h3 class="sa-step-question">Vilken passform föredrar du?</h3>'
      + note
      + '<div class="sa-options">'
        + '<button class="sa-option" data-action="fit" data-value="oversized">'
          + '<span class="sa-option-title">Oversized</span>'
          + '<span class="sa-option-desc">L\u00f6s och avslappnad \u2014 den d\u00e4r k\u00e4nslan av att ha l\u00e5nat en kompis tr\u00f6ja</span>'
        + '</button>'
        + '<button class="sa-option" data-action="fit" data-value="regular">'
          + '<span class="sa-option-title">Normalpassform</span>'
          + '<span class="sa-option-desc">Klassisk passform \u2014 varken f\u00f6r l\u00f6s eller f\u00f6r tajt</span>'
        + '</button>'
      + '</div>'
    + '</div>';
  }

  // ── STEP 1 — Usual size ────────────────────────────────────
  function renderSizeStep() {
    if (betweenMode) return renderBetweenSizes();

    var sizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
    var btns = sizes.map(function (s) {
      return '<button class="sa-option sa-option--compact" data-action="size" data-value="' + s + '">' + s + '</button>';
    }).join('');

    return '<div class="sa-step">'
      + backBtn(0)
      + '<p class="sa-step-label">Steg 2 av 3</p>'
      + '<h3 class="sa-step-question">Vilken storlek har du vanligtvis?</h3>'
      + '<div class="sa-options sa-options--grid">'
        + btns
        + '<button class="sa-option sa-option--compact sa-option--wide" data-action="between">'
            + 'Jag \u00e4r mellan tv\u00e5 storlekar'
          + '</button>'
      + '</div>'
    + '</div>';
  }

  // ── STEP 1b — Between two sizes ────────────────────────────
  function renderBetweenSizes() {
    var sizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
    function opts(defaultVal) {
      return sizes.map(function (s) {
        return '<option value="' + s + '"' + (s === defaultVal ? ' selected' : '') + '>' + s + '</option>';
      }).join('');
    }

    return '<div class="sa-step">'
      + backBtn('size-grid')
      + '<p class="sa-step-label">Steg 2 av 3</p>'
      + '<h3 class="sa-step-question">Vilka tv\u00e5 storlekar?</h3>'
      + '<div class="sa-between">'
        + '<div class="sa-between-selects">'
          + '<select id="sa-between-low"  class="sa-select">' + opts('M') + '</select>'
          + '<span  class="sa-between-sep">och</span>'
          + '<select id="sa-between-high" class="sa-select">' + opts('L') + '</select>'
        + '</div>'
        + '<button class="sa-btn sa-btn--primary" id="sa-between-confirm">N\u00e4sta</button>'
      + '</div>'
    + '</div>';
  }

  // ── STEP 2 — Height & weight ───────────────────────────────
  function renderMeasurementsStep() {
    return '<div class="sa-step">'
      + backBtn(1)
      + '<p class="sa-step-label">Steg 3 av 3</p>'
      + '<h3 class="sa-step-question">L\u00e4ngd &amp; vikt <span class="sa-optional">(valfritt)</span></h3>'
      + '<p class="sa-step-desc">Hj\u00e4lper oss att ge en mer exakt rekommendation.</p>'
      + '<div class="sa-field-group">'
        + '<div class="sa-field">'
          + '<label class="sa-label" for="sa-height">L\u00e4ngd</label>'
          + '<select id="sa-height" class="sa-select">'
            + '<option value="">Vill inte uppge</option>'
            + '<option value="under155">Under 155 cm</option>'
            + '<option value="155-165">155 \u2013 165 cm</option>'
            + '<option value="165-175">165 \u2013 175 cm</option>'
            + '<option value="175-185">175 \u2013 185 cm</option>'
            + '<option value="185-195">185 \u2013 195 cm</option>'
            + '<option value="over195">\u00d6ver 195 cm</option>'
          + '</select>'
        + '</div>'
        + '<div class="sa-field">'
          + '<label class="sa-label" for="sa-weight">Vikt</label>'
          + '<select id="sa-weight" class="sa-select">'
            + '<option value="">Vill inte uppge</option>'
            + '<option value="under55">Under 55 kg</option>'
            + '<option value="55-65">55 \u2013 65 kg</option>'
            + '<option value="65-75">65 \u2013 75 kg</option>'
            + '<option value="75-85">75 \u2013 85 kg</option>'
            + '<option value="85-100">85 \u2013 100 kg</option>'
            + '<option value="over100">\u00d6ver 100 kg</option>'
          + '</select>'
        + '</div>'
      + '</div>'
      + '<div class="sa-actions">'
        + '<button class="sa-btn sa-btn--primary" id="sa-see-result">Visa min storlek</button>'
        + '<button class="sa-btn sa-btn--ghost"   id="sa-skip-step">Hoppa \u00f6ver det h\u00e4r steget</button>'
      + '</div>'
    + '</div>';
  }

  // ── STEP 3 — Result ────────────────────────────────────────
  function renderResult() {
    var chart     = SIZE_CHARTS[productType];
    var available = chart.sizes;

    // ── Derive consensus from reviews ──
    var typeReviews = SIZE_REVIEWS.filter(function (r) {
      return normalizeType((r.product_type || '').toLowerCase()) === productType;
    });

    var fitAdjust     = 0;
    var avgScore      = null;
    var consensusText = '';
    var consensusKey  = '';

    if (typeReviews.length > 0) {
      avgScore = typeReviews.reduce(function (sum, r) { return sum + r.fit_score; }, 0) / typeReviews.length;
      if (avgScore < 40) {
        fitAdjust     = 1;  // runs small → size up
        consensusText = 'De flesta kunder s\u00e4ger att den \u00e4r liten i storleken \u2014 vi har valt en storlek upp.';
        consensusKey  = 'small';
      } else if (avgScore > 60) {
        fitAdjust     = -1; // runs large → size down
        consensusText = 'De flesta kunder s\u00e4ger att den \u00e4r stor i storleken \u2014 vi har valt en storlek ned.';
        consensusKey  = 'large';
      } else {
        consensusText = 'De flesta kunder s\u00e4ger att den passar i normal storlek.';
        consensusKey  = 'true';
      }
    }

    // ── Derive base index from user's stated size ──
    var baseIdx;
    if (answers.betweenLow && answers.betweenHigh) {
      // Between two sizes: start from the larger one
      baseIdx = findClosestIdx(answers.betweenHigh, available);
    } else {
      baseIdx = findClosestIdx(answers.size, available);
    }

    // ── Oversized adjustment (hoodies only) ──
    var oversizedAdjust = 0;
    if (!isKidsType(productType) && answers.fit === 'oversized') {
      oversizedAdjust = 1;
    }

    // ── Clamp final index to available range ──
    var finalIdx   = Math.max(0, Math.min(available.length - 1, baseIdx + fitAdjust + oversizedAdjust));
    var recommended = available[finalIdx];
    var meas        = chart.measurements[recommended];

    // ── Build explanation & quotes ──
    var explanation = buildExplanation(answers, fitAdjust, oversizedAdjust, recommended);
    var quotes      = getRelevantQuotes(typeReviews, avgScore);
    var tableHTML   = buildSizeTable(chart, recommended);

    return '<div class="sa-result">'

      // ── Hero block ──
      + '<div class="sa-result-hero">'
        + '<p class="sa-result-label">Vi rekommenderar</p>'
        + '<div class="sa-result-size">' + recommended + '</div>'
        + (meas
            ? '<p class="sa-result-measurements">Bredd ' + meas.width + ' cm &nbsp;&middot;&nbsp; L\u00e4ngd ' + meas.length + ' cm</p>'
            : '')
      + '</div>'

      // ── Explanation ──
      + '<p class="sa-result-explanation">' + explanation + '</p>'

      // ── Consensus ──
      + (consensusText
          ? '<div class="sa-consensus">'
              + '<span class="sa-consensus-dot sa-consensus-dot--' + consensusKey + '"></span>'
              + esc(consensusText)
            + '</div>'
          : '')

      // ── Quotes ──
      + (quotes.length
          ? '<div class="sa-quotes">'
              + quotes.map(function (q) {
                  return '<div class="sa-quote-card">'
                    + '<p class="sa-quote-text">&ldquo;' + esc(q.quote) + '&rdquo;</p>'
                    + '<p class="sa-quote-meta">' + esc(q.reviewer) + '</p>'
                  + '</div>';
                }).join('')
            + '</div>'
          : '')

      // ── Size table ──
      + '<details class="sa-size-table-wrapper">'
        + '<summary class="sa-size-table-toggle">Visa fullst\u00e4ndig storleksguide</summary>'
        + tableHTML
      + '</details>'

      // ── Restart ──
      + '<button class="sa-btn sa-btn--primary" id="sa-apply-size" data-size="' + recommended + '">Anv\u00e4nd storlek ' + recommended + '</button>'
      + '<button class="sa-btn sa-btn--ghost" id="sa-restart">B\u00f6rja om</button>'

    + '</div>';
  }

  // ── HELPERS ────────────────────────────────────────────────

  /**
   * Find the index in `available` that best matches `size`
   * by comparing numeric size ranks.
   */
  function findClosestIdx(size, available) {
    var exact = available.indexOf(size);
    if (exact !== -1) return exact;

    var targetRank = sizeRank(size);
    var bestIdx  = 0;
    var bestDist = Infinity;
    for (var i = 0; i < available.length; i++) {
      var dist = Math.abs(sizeRank(available[i]) - targetRank);
      if (dist < bestDist) { bestDist = dist; bestIdx = i; }
    }
    return bestIdx;
  }

  /**
   * Build a natural-language explanation sentence.
   * Handles all combinations of between-sizes, fit preference,
   * fit-score adjustment, and oversized adjustment.
   */
  function buildExplanation(ans, fitAdj, oversizedAdj, recommended) {
    var reasons = [];

    if (productType === 'baby') {
      reasons.push('din baby \u00e4r i storleken ' + ans.size);
    } else if (productType === 'junior') {
      reasons.push('barnets l\u00e4ngd passar storlek ' + ans.size);
    } else if (ans.betweenLow && ans.betweenHigh) {
      reasons.push('du \u00e4r mellan ' + ans.betweenLow + ' och ' + ans.betweenHigh);
    } else {
      reasons.push('din vanliga storlek \u00e4r ' + ans.size);
    }

    if (ans.fit === 'oversized' && oversizedAdj > 0) {
      reasons.push('du föredrar en oversized' + (productType === 'hoodie' ? ' hoodie' : '') + '-passform');
    } else if (ans.fit === 'oversized' && oversizedAdj === 0) {
      // Oversized chosen but not a hoodie — note it without adding an extra size
      reasons.push('du föredrar en avslappnad och rymlig passform');
    }

    if (fitAdj > 0)      reasons.push('den h\u00e4r stilen \u00e4r lite liten i storleken');
    else if (fitAdj < 0) reasons.push('den h\u00e4r stilen \u00e4r lite stor i storleken');

    var joined;
    if (reasons.length === 1) {
      joined = reasons[0];
    } else if (reasons.length === 2) {
      joined = reasons[0] + ' och ' + reasons[1];
    } else {
      joined = reasons.slice(0, -1).join(', ') + ' och ' + reasons[reasons.length - 1];
    }

    return 'Eftersom ' + joined + ' rekommenderar vi <strong>' + esc(recommended) + '</strong>.';
  }

  /**
   * Return up to 2 reviews with quotes, sorted by closeness to the
   * average fit score (i.e. the most "representative" reviews).
   */
  function getRelevantQuotes(reviews, avgScore) {
    var withQuotes = reviews.filter(function (r) { return r.quote && r.quote.trim() && r.show_quote === true; });
    if (!withQuotes.length) return [];
    if (avgScore === null)  return withQuotes.slice(0, 2);

    var sorted = withQuotes.slice().sort(function (a, b) {
      var distA = Math.abs(a.fit_score - avgScore);
      var distB = Math.abs(b.fit_score - avgScore);
      if (distA !== distB) return distA - distB;
      return Math.random() - 0.5;
    });
    return sorted.slice(0, 2);
  }

  /** Build the size-chart HTML table, highlighting the recommended size. */
  function buildSizeTable(chart, recommended) {
    var rows = chart.sizes.map(function (s) {
      var m      = chart.measurements[s];
      var isRec  = s === recommended;
      var cls    = isRec ? ' class="sa-table-row--recommended"' : '';
      var marker = isRec ? ' <span aria-label="recommended">&#9664;</span>' : '';
      return '<tr' + cls + '>'
        + '<td>' + esc(s) + marker + '</td>'
        + '<td>' + m.width  + '</td>'
        + '<td>' + m.length + '</td>'
      + '</tr>';
    }).join('');

    return '<table class="sa-table">'
      + '<thead><tr><th>Storlek</th><th>Bredd (cm)</th><th>L\u00e4ngd (cm)</th></tr></thead>'
      + '<tbody>' + rows + '</tbody>'
    + '</table>';
  }

  /** Minimal HTML escape to guard against unexpected data in reviews. */
  function esc(str) {
    return String(str)
      .replace(/&/g,  '&amp;')
      .replace(/</g,  '&lt;')
      .replace(/>/g,  '&gt;')
      .replace(/"/g,  '&quot;')
      .replace(/'/g,  '&#39;');
  }

  // ── EVENT LISTENERS ────────────────────────────────────────
  function attachListeners() {

    // Step 0 — fit preference
    $body.querySelectorAll('[data-action="fit"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        answers.fit = btn.getAttribute('data-value');
        currentStep = 1;
        betweenMode = false;
        renderStep();
      });
    });

    // Step 0 — kids size (baby age / junior height) → jump straight to result
    $body.querySelectorAll('[data-action="kidssize"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        answers.size = btn.getAttribute('data-value');
        currentStep = 3;
        renderStep();
      });
    });

    // Step 1 — size selection
    $body.querySelectorAll('[data-action="size"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        answers.size       = btn.getAttribute('data-value');
        answers.betweenLow = null;
        answers.betweenHigh = null;
        currentStep = 2;
        renderStep();
      });
    });

    // Step 1 — enter between-sizes sub-screen
    var betweenBtn = $body.querySelector('[data-action="between"]');
    if (betweenBtn) {
      betweenBtn.addEventListener('click', function () {
        betweenMode  = true;
        answers.size = 'between';
        renderStep(); // currentStep stays 1
      });
    }

    // Step 1b — confirm between-sizes selection
    var confirmBtn = document.getElementById('sa-between-confirm');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        var low  = document.getElementById('sa-between-low').value;
        var high = document.getElementById('sa-between-high').value;
        // Guarantee low rank <= high rank
        if (sizeRank(high) < sizeRank(low)) { var tmp = low; low = high; high = tmp; }
        answers.betweenLow  = low;
        answers.betweenHigh = high;
        currentStep = 2;
        renderStep();
      });
    }

    // Step 2 — see result (with measurements)
    var seeResultBtn = document.getElementById('sa-see-result');
    if (seeResultBtn) {
      seeResultBtn.addEventListener('click', function () {
        answers.height = document.getElementById('sa-height').value;
        answers.weight = document.getElementById('sa-weight').value;
        currentStep = 3;
        renderStep();
      });
    }

    // Step 2 — skip measurements
    var skipBtn = document.getElementById('sa-skip-step');
    if (skipBtn) {
      skipBtn.addEventListener('click', function () {
        currentStep = 3;
        renderStep();
      });
    }

    // Result — restart
    var restartBtn = document.getElementById('sa-restart');
    if (restartBtn) {
      restartBtn.addEventListener('click', function () {
        currentStep = 0;
        answers     = {};
        betweenMode = false;
        renderStep();
      });
    }

    // Back buttons (any step)
    $body.querySelectorAll('[data-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-back');
        if (target === 'size-grid') {
          // Return to normal size grid from between-sizes sub-screen
          betweenMode = false;
          currentStep = 1;
        } else {
          currentStep = parseInt(target, 10);
          if (currentStep === 0) betweenMode = false;
        }
        renderStep();
      });
    });

    // Result — apply recommended size to variant selector
    var applyBtn = document.getElementById('sa-apply-size');
    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        var size = applyBtn.getAttribute('data-size');

        // Try multiple common variations of the size label
        var candidates = [size];
        if (size === 'XXXL') candidates.push('3XL', 'XXL');
        if (size === 'XXL')  candidates.push('2XL');
        if (size === '3XL')  candidates.push('XXXL');
        if (size === '2XL')  candidates.push('XXL');

        var allInputs = document.querySelectorAll(
          'input[type="radio"][name*="Size"], input[type="radio"][name*="Storlek"]'
        );
        for (var c = 0; c < candidates.length; c++) {
          for (var i = 0; i < allInputs.length; i++) {
            if (allInputs[i].value.toUpperCase() === candidates[c].toUpperCase()) {
              allInputs[i].click();
              closePanel();
              return;
            }
          }
        }
      });
    }
  }

  // ── BOOT ───────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());
